import React, { useContext, forwardRef } from 'react';
import clsx from 'clsx';
import { Element } from '../../element';
import Context from '../context';
import * as styles from '../list.styles';

/** @type {typeof import("..").ListItem} */
const ListItem = forwardRef(({ className, children, ...props }, ref) => {
  const variant = useContext(Context);
  return (
    <Element ref={ref} as="li" className={clsx(styles.components.item, { [styles.variants[variant]]: variant }, className)} {...props}>
      {children}
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  ListItem.displayName = 'List.Item';
}

export default ListItem;
